export default __webpack_public_path__ + "static/article-2-32a72c69d396619e254aa707e9501982.jpg";